/**
 * Created by bscholl on 16.02.17.
 */
import template from './gauge.tpl';
import DomUtil from '@/core/utils/domUtil';
import styles from './gauge.module.scss';
import ContentModel from "@/app/model/contentModel";


export default class Gauge {
    public element: HTMLElement | null = null;

    private common: any;
    private minimum: number;
    private maximum: number;
    private max_steps: number;
    private rad: number;
    private NS: string;
    private tickLength: number;
    private needleColor: string;
    private needle: SVGPolygonElement | null = null;
    private svg: SVGSVGElement | null = null;
    private _target: HTMLElement | null = null;
    private initVal: number = 0;
    private cx: number = 0;
    private cy: number = 0;
    private r1: number = 0;
    private r2: number = 0;
    private delta: number = 0;
    private offset: number = 0;


    constructor(minimum = 0, maximum = 100) {
        this.common = ContentModel.instance.getCommonData();

        this.element = document.createElement('div');
        this.element.innerHTML = template({styles: styles});
        this.element = this.element.firstChild as HTMLElement;

        this.minimum = minimum;
        this.maximum = maximum;
        this.max_steps = maximum - minimum;

        this.rad = Math.PI / 180;
        this.NS = 'http://www.w3.org/2000/svg';
        this.tickLength = 28;
        this.needleColor = this.common.colors["icon-dark"]; // Default color, will be set based on gender if available

        //console.log("min, max, steps", minimum, maximum, this.max_steps);
    }


    setSVGAttributes(elmt: SVGElement, oAtt: Record<string, any>) {
        for (let prop in oAtt) {
            elmt.setAttributeNS(null, prop, oAtt[prop]);
        }
    }

    drawNeedle(cx, cy, r1, a) {
        let w = 2;
        let h = 30;
        r1 = r1 - this.tickLength;

        let nx1 = cx + w * Math.cos((a - 90) * this.rad) + (r1) * Math.cos(a * this.rad);
        let ny1 = cy + w * Math.sin((a - 90) * this.rad) + (r1) * Math.sin(a * this.rad);

        let nx2 = cx + w * Math.cos((a - 90) * this.rad) + (r1 + h) * Math.cos(a * this.rad);
        let ny2 = cy + w * Math.sin((a - 90) * this.rad) + (r1 + h) * Math.sin(a * this.rad);

        let nx3 = cx - w * Math.cos((a - 90) * this.rad) + (r1 + h) * Math.cos(a * this.rad);
        let ny3 = cy - w * Math.sin((a - 90) * this.rad) + (r1 + h) * Math.sin(a * this.rad);

        let nx4 = cx + w * Math.cos((a + 90) * this.rad) + (r1) * Math.cos(a * this.rad);
        let ny4 = cy + w * Math.sin((a + 90) * this.rad) + (r1) * Math.sin(a * this.rad);

        let points = nx1 + ',' + ny1 + ' ' + nx2 + ',' + ny2 + ' ' + nx3 + ',' + ny3 + ' ' + nx4 + ',' + ny4;
        if (this.needle) {
            this.needle.setAttributeNS(null, 'points', points);
            this.needle.style.fill = this.needleColor;
        }
    }

    private getScaleByMidpointProximity(value: number, min: number, max: number, lowerLimit: number = 0.5): number {
        // Calculate how close a value is from a midpoint (as a percentage of the total range)
        const midpoint = min + (max - min) / 2;
        const totalRange = Math.abs(max - min);
        const distanceFromMidpoint = Math.abs(value - midpoint);
        const proximityRatio = 1 - (distanceFromMidpoint / (totalRange / 2));

        // Return a %-scale between {lowerLimit} and 1, where:
        // - 1.0 means value is exactly at the midpoint
        // - {lowerLimit} means value is at either min/max range
        return lowerLimit + (Math.max(0, proximityRatio) * (1 - lowerLimit));
    }

    set inputValue(value) {
        // this.initVal = value - this.minimum;
        //
        // let startAngle = 300;
        // let endAngle = 60;
        // let pa = this.initVal * (startAngle / this.max_steps) - startAngle + endAngle;
        //
        // //console.log("NEW INIT VAL:", this.initVal, pa);
        // this.drawNeedle(this.cx, this.cy, this.r1, pa);
    }

    drawTicks(ticks: number, tickMarkedInterval: number = 0) {

        let startAngle = 90;  // 90 = start at bottom
        let degreeSpan = 360;  // 360 = fill whole circle with ticks

        let ticksContainer = this.svg?.querySelector('.scale');
        if (!ticksContainer) return;

        let style = 'tick';
        for (let nTick = ticks - 1; nTick >= 0; nTick--) {
            if (tickMarkedInterval && (ticks - nTick) % tickMarkedInterval == 0) {
                style += ` ${styles.marked}`;
            }

            // draw tick from inside radial, outwards
            let tickLength = this.tickLength * this.getScaleByMidpointProximity(nTick, 0, ticks);
            let tAngle = -degreeSpan / ticks * nTick + startAngle;
            let tFrom = this.r1;
            let tTo = this.r1 + tickLength;

            // calc rotation and position
            let xFrom = this.cx + tFrom * Math.cos(tAngle * this.rad);
            let yFrom = this.cy + tFrom * Math.sin(tAngle * this.rad);
            let xTo = this.cx + tTo * Math.cos(tAngle * this.rad);
            let yTo = this.cy + tTo * Math.sin(tAngle * this.rad);

            let tick = document.createElementNS(this.NS, 'line');
            let tickAttr = {
                class: style,
                x1: xFrom,
                y1: yFrom,
                x2: xTo,
                y2: yTo
            };

            this.setSVGAttributes(tick as SVGElement, tickAttr);
            ticksContainer.appendChild(tick);
        }
    }

    destroy() {
        if (this._target && this.element && DomUtil.isDescendant(this._target, this.element)) {
            this._target.removeChild(this.element);
        }

        this.element = null;
    }

    appendTo(target: HTMLElement) {
        this._target = target;
        if (this.element) {
            this._target.appendChild(this.element);
        }

        this.svg = this._target.querySelector('svg#typerange') as SVGSVGElement;
        this.needle = this.svg?.querySelector('polygon') as SVGPolygonElement;

        let svgWidth = 670;

        this.offset = 104;

        this.cx = ~~(svgWidth / 2);
        this.cy = ~~(svgWidth / 2);

        this.r1 = this.cx - this.offset;
        this.delta = ~~(this.r1 / 8);
        this.r2 = this.r1 - this.delta;

        this.drawTicks(60);

    }

    getElement(): SVGSVGElement | null {
        return this.svg;
    }


}
